import { SubscriptionEventSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Subscription audit events — append-only ledger written by Cloud Functions
 * (addOutlet, removeOutlet, monthlyBilling). Read-only from the dashboard.
 *
 *   tenants/{tid}/subscriptionEvents/{eventId}
 *
 * Powers the "Closing on YYYY-MM-DD — Undo" affordance on /outlets and the
 * future billing audit panel in /billing.
 */
export function subscriptionEventsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/subscriptionEvents`,
    schema: SubscriptionEventSchema,
    name: `tenants/${tenantId}/subscriptionEvents`,
  });
}
